export default __webpack_public_path__ + "media/images/promo-block/event-details-694353b0bd194f45eeff1d5d22ea2de9.gif";